import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	deleteSchemeFlagTitle: {
		id: 'admin-pages-priority-schemes.controllers.delete-priority-scheme.delete-scheme-flag-title',
		defaultMessage: 'The priority scheme "{schemeName}" is deleted',
		description: 'title for jira flag for successfully deleting a priority scheme',
	},
	deleteUnexpectedErrorFlagTitle: {
		id: 'admin-pages-priority-schemes.controllers.delete-priority-scheme.delete-unexpected-error-flag-title',
		defaultMessage: 'We couldn’t delete the priority scheme',
		description:
			'Title for jira flag when there is an unexpected error when trying to delete a scheme',
	},
	deleteUnexpectedErrorFlagDescription: {
		id: 'admin-pages-priority-schemes.controllers.delete-priority-scheme.delete-unexpected-error-flag-description',
		defaultMessage: 'Refresh to try again.',
		description:
			'Title for jira flag when there is an unexpected error when trying to delete a scheme',
	},
});
